import { Outlet } from "react-router-dom";
import { InvoiceImportProvider } from "./InvoiceImportProvider";

export function InvoiceImportRoutes() {
  return (
    <InvoiceImportProvider>
      <Outlet />
    </InvoiceImportProvider>
  );
}
